const groupPrefix = createApiRoute(ApiModule.ORDER, ApiAuthorization.EMPLOYEE, ApiDataModel.ADDRESS)

export const apiClientAddresses = {
	fetchClientAddresses: async (clientUUID: string): Promise<IClientAddressModel[]> => {
		const { data } = await apiCommon<IClientAddress[]>(`${groupPrefix}/${clientUUID}`, { method: 'GET' })

		return data.map(d => ClientAddress(d))
	},

	createClientAddress: async (payload: IClientAddressCreateModel): Promise<IClientAddressModel> => {
		const body = ClientAddressManageToJson(payload)

		const { data } = await apiCommon<IClientAddress>(`${groupPrefix}`, {
			method: 'POST',
			body,
		})

		return ClientAddress(data)
	},

	updateClientAddress: async (payload: IClientAddressUpdateModel): Promise<IClientAddressModel> => {
		const body = ClientAddressManageToJson(payload)

		const { data } = await apiCommon<IClientAddress>(`${groupPrefix}/${payload.uuid}`, {
			method: 'PATCH',
			body,
		})

		return ClientAddress(data)
	},

	deleteClientAddress: async (addressUUID: string): Promise<void> => {
		await apiCommon(`${groupPrefix}/${addressUUID}/hide`, { method: 'POST' })
	},
}
